import React from 'react';
import Button from '@app/components/ui/button';
import { ResponsibilityDto } from '@app/models/dtos/strapi';

interface IVacancyResponsibility {
    responsibilities: Array<ResponsibilityDto | null>;
    handleApply: () => void;
}

function VacancyResponsibility({ responsibilities, handleApply }: IVacancyResponsibility) {
    return (
        <div>
            <p className="h4-responsive">Job Responsibilities</p>
            <ul className="P1 mb-[60px] mt-6 list-disc pl-6">
                {responsibilities.map((responsibility) => (
                    <li key={responsibility?.id} className="py-3">
                        {responsibility?.responsibility}
                    </li>
                ))}
            </ul>
            <Button size="large" onClick={handleApply}>
                Apply Now
            </Button>
        </div>
    );
}

export default VacancyResponsibility;
